import { useState } from "react";
import { pickEmptyCommentMessage } from "../constants/emptyCommentMessages";

/**
 * One random empty-thread line per mount (page load / remount).
 * Not derived from render, memo deps, or a rotating index.
 */
export default function EmptyCommentLine({ className }) {
  const [message] = useState(pickEmptyCommentMessage);
  return (
    <p className={className} data-testid="empty-comment-line">
      {message}
    </p>
  );
}
